export default __webpack_public_path__ + "media/images/elephant_ui_greeting-ac9ab50cd25056ac6178dda552978e70.svg";